const FUND_ACCOUNT_SOURCES = {
  static: {
    desc: 'Enter account ID',
  },
  rules: {
    desc: 'Use rules',
    requires_engine_readiness: true,
  },
} as const;

export default FUND_ACCOUNT_SOURCES;
